import DescriptionList from 'ant-design-pro/lib/DescriptionList';
import Description from 'ant-design-pro/lib/DescriptionList/Description';
import PageHeader from 'ant-design-pro/lib/PageHeader';
import { Button, Empty, Icon, Input, Table } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Panel } from 'src/components/Panel';
import { FormatDate } from 'src/components/table/Date';

import { UserData } from './Enrollment';

const attendancelogsQuery = gql`
  query getAttendancelogsQuery(
    $ids: [ID]
    $enrollmentIds: [Int]
    $lessonIds: [ID]
    $attendanceIds: [ID]
    $serialId: String
  ) {
    users(ids: $ids) {
      id
      name
      enrollments(ids: $enrollmentIds) {
        id
        skuId
        sku {
          id
          name
        }
        lessonProgresses(serialId: $serialId) {
          serialId
          lesson {
            id
            name
            type
          }
        }
        attendances(lessonIds: $lessonIds, attendanceIds: $attendanceIds) {
          id
          lessonId
          enrollmentId
          uuid
          parts
          attendanceLogs {
            id
            key
            event
            createdAt
            happenedAt
            attendanceId
            sequence
          }
        }
      }
    }
  }
`;

interface Props {
  match: any;
}

interface State {
  searchText: React.Key;
}

export class AttendanceLogs extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      searchText: '',
    };
  }

  searchByDataIndex = (selectedKeys?: React.Key[], confirm?: () => void) => {
    if (!selectedKeys || !confirm) {
      return;
    }
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters?: () => void) => {
    if (clearFilters) {
      clearFilters();
    }

    this.setState({ searchText: '' });
  };

  private searchInput: Input | null;
  getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: (props: FilterDropdownProps) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={props.selectedKeys && props.selectedKeys[0]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            props.setSelectedKeys && props.setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.searchByDataIndex(props.selectedKeys && props.selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.searchByDataIndex(props.selectedKeys && props.selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜索
        </Button>
        <Button
          onClick={() => this.handleReset(props.clearFilters && props.clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          重置
        </Button>
      </div>
    ),
    filterIcon: (filtered: boolean) => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value: string, record: any) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible: boolean) => {
      if (visible) {
        setTimeout(() => this.searchInput && this.searchInput.select());
      }
    },
  });

  render() {
    const { id, enrollmentId, lessonId, attendanceId, serialId } = this.props.match.params;
    const columns = [
      {
        title: 'ID',
        key: 'id',
        dataIndex: 'id',
        ...this.getColumnSearchProps('id'),
      },
      {
        title: 'attendanceId',
        key: 'attendanceId',
        dataIndex: 'attendanceId',
      },
      {
        title: 'key',
        key: 'key',
        dataIndex: 'key',
        ...this.getColumnSearchProps('key'),
      },
      {
        title: 'event',
        key: 'event',
        dataIndex: 'event',
      },
      {
        title: 'happenedAt',
        key: 'happenedAt',
        dataIndex: 'happenedAt',
        render: (happenedAt: Date) => <FormatDate mode="datetime" date={happenedAt} />,
      },
      {
        title: 'createdAt',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: (createdAt: Date) => <FormatDate mode="datetime" date={createdAt} />,
      },
    ];
    return (
      <Query<UserData>
        query={attendancelogsQuery}
        variables={{
          serialId,
          lessonIds: [lessonId],
          attendanceIds: [attendanceId],
          ids: [id],
          enrollmentIds: [enrollmentId],
        }}
        fetchPolicy="no-cache"
      >
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = (data && data.users) || [null];
          const [enrollment] = user && user.enrollments;
          const sku = enrollment && enrollment.sku;
          const [attendance] = enrollment && enrollment.attendances;
          const attendanceLogs = attendance && attendance.attendanceLogs;
          const lessonProgresses = enrollment && enrollment.lessonProgresses;
          const [lessonProgress] = lessonProgresses;
          return (
            <>
              <PageHeader
                title={sku.name}
                content={
                  enrollment && (
                    <DescriptionList size="small" title="课程">
                      <Description term="课时">{lessonProgress.lesson.name}</Description>
                    </DescriptionList>
                  )
                }
              />
              <Panel style={{ marginTop: 10 }}>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={attendanceLogs}
                  rowKey={attenanceLog => `${attenanceLog.id || attenanceLog.sequence}`}
                />
              </Panel>
            </>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/AttendanceLogs.tsx